import DeviceActivityAPIWorker from '~/utils/workers/deviceActivity.worker?worker'

let worker: Worker
export const initiateDeviceActivityWorker = async () => {
  const config = useRuntimeConfig()
  const { $api: api } = useNuxtApp()
  if (worker) worker?.terminate()
  worker = new DeviceActivityAPIWorker()
  const userStore = useUserStore()
  setDeviceActivity(api, userStore)

  const message = {
    base_url: config.public.BACK_URL,
    urls: [`/auth/practitioners`],
    token: userStore.token,
    userId: userStore.uid,
    deviceId: deviceID(),
  }
  worker.postMessage(JSON.stringify(message))

  worker.onmessage = async (event) => {
    if (event.data !== 'error') {
      setDeviceActivity(api, userStore)
    }
  }
}

const setDeviceActivity = (api: any, userStore: any) => {
  const isUserActive = navigator?.userActivation?.isActive

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      await api.auth.trackDeviceActivity(userStore.user.uid as string, deviceID() as string, {
        active: isUserActive,
        deviceType: 'web',
        geolocation: {
          latitude: position.coords?.latitude,
          longitude: position.coords?.longitude,
        },
      })
    },
    async () => {
      await api.auth.trackDeviceActivity(userStore.user.uid as string, deviceID() as string, {
        active: isUserActive,
        deviceType: 'web',
      })
    },
  )
}

export const stopDeviceActivityWebWorker = () => {
  worker.postMessage(JSON.stringify({ type: 'stop' }))
  worker?.terminate()
}
